export default class Schedule {
  constructor() {
    this._list = []
    this._promiseList = []
  }

  add(task = (resolve) => {}) {
    this._list.push(async () => {
      const promise = new Promise((resolve) => {
        task(resolve)
      })
      this._promiseList.push(promise)
      await promise
    })
  }

  done(callback = () => {}) {
    this._list
      .reduce((prev, current) => prev.then(current), Promise.resolve())
      .then(() => {
        Promise.all(this._promiseList).then(callback)
      })
  }
}